import { render, staticRenderFns } from "./ChamberSearch.vue?vue&type=template&id=180f854c"
import script from "./ChamberSearch.vue?vue&type=script&lang=js"
export * from "./ChamberSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports